
import { getFeature } from "../utils/features";
import { useIsInStockContext } from "../context/isInStock/IsInStockContext";

export default function useSizeGuideExperimentBucket({
  excludedFromSizeGuideExperiment = false,
  isProductFullyOutOfStock = undefined,
} = {}) {
  const { isEnabled, getVariables } = getFeature("web-pdp-size-guide");
  const { isInStock } = useIsInStockContext?.() || {};

  let isOOS = isProductFullyOutOfStock;
  if (typeof isOOS === "undefined") {
    isOOS = isInStock === false;
  }

  if (excludedFromSizeGuideExperiment || isOOS) return "v0";
  if (!isEnabled()) return "v0";

  return getVariables()?.bucket || "v1";
}
